import { FormEvent } from "react";

export type FormProperties = {
  currentProvider?: string | null;
  finishAuthUrl?: string | null;
};

export type SwitchCallbackElementSet =
  | HTMLAnchorElement
  | HTMLButtonElement
  | FormEvent<Element>;
export type SwitchCallbackMouseEvent =
  | React.MouseEvent<SwitchCallbackElementSet>
  | undefined;
export type SwitchCallback = (
  e: SwitchCallbackMouseEvent,
  skipReplaceBase?: boolean,
) => void;

export type LoginFormProperties = FormProperties & {
  passwordResetComplete: boolean;
  switchToPasswordRecovery: SwitchCallback;
  isModal?: boolean;
};

export enum StartAsPage {
  // Standard Flow
  Login = "login",
  Register = "register",

  // Forgot Password Flow
  ForgotPassword = "reset",
  ForgotPasswordConfirm = "password_reset_confirm",
}

export const PasswordRecoveryPages: StartAsPage[] = [
  StartAsPage.ForgotPasswordConfirm,
  StartAsPage.ForgotPassword,
] as const;
